<template>
  <div class="InteractiveForm current-form">
    <FormVee ref="observer" class="step-form" as="div" @submit="() => {}">
      <div v-if="busy" key="loading" class="loading">
        <Spinner />
      </div>
      <transition-group
        v-else
        key="content"
        tag="div"
        class="form-content"
        name="slide"
        appear
      >
        <slot
          key="slot"
          :validation="validation"
          :step="currentStep"
          :index="cptdCurrentStepIndex"
        />
      </transition-group>

      <slot name="additional-content" />

      <Button
        v-if="cptdDisplayNextButton"
        :busy="busy"
        type="outlined"
        @click="next"
      >
        Continuar
      </Button>
    </FormVee>
  </div>
</template>
<script>
import Spinner from '@/aasgard/components/feedback/Spinner.vue'
import Button from '@/aasgard/components/buttons/Button.vue'
export default {
  name: 'InteractiveForm',
  components: {
    Spinner,
    Button,
  },
  props: {
    busy: { type: Boolean, default: false },
    hideNextButton: { type: Boolean, default: false },
    currentForm: { type: String, default: '' },
    steps: { type: Array, default: () => [] },
    autoSelectableSteps: { type: Array, default: () => [] },
  },
  emits: ['submit'],
  data() {
    return {
      formIsValid: false,
      currentStep: '',
      validation: false,
    }
  },
  computed: {
    cptdDisplayNextButton() {
      return (
        !this.busy &&
        !this.autoSelectableSteps?.includes(this.currentStep) &&
        this.currentStep &&
        !this.hideNextButton
      )
    },
    cptdPreviousStep() {
      const previousStepIndex = this.cptdCurrentStepIndex - 1
      return {
        key: this.steps[previousStepIndex] || null,
        index: previousStepIndex,
      }
    },
    cptdNextStep() {
      const nextStepIndex = this.cptdCurrentStepIndex + 1
      return {
        key: this.steps[nextStepIndex] || null,
        index: this.steps[nextStepIndex] ? nextStepIndex : null,
      }
    },
    cptdCurrentStepIndex() {
      const index = this.steps.indexOf(this.currentStep)
      return index !== -1 ? index : 0
    },
  },
  created() {
    this.gEventBus.on('layout-unlogged:back-clicked', this.back)
  },
  mounted() {
    this.currentStep = this.steps[0]
    this.setRouteParams()
    this.gEventBus.emit('layout-unlogged:hide-back-button')
  },
  methods: {
    setRouteParams() {
      this.$router.push({
        path: this.$route.path,
        query: {
          ...this.$route.query,
          form: this.currentForm,
          step: this.currentStep,
        },
        replace: true,
      })
    },
    back() {
      if (this.cptdPreviousStep.key) {
        if (this.cptdPreviousStep.index === 0) {
          this.gEventBus.emit('layout-unlogged:hide-back-button')
        }
        this.currentStep = this.steps[this.cptdPreviousStep.index]
        this.setRouteParams()
      }
    },
    async checkForm() {
      this.validation = true
      const formValidationResult = await this.$refs.observer?.validate()
      this.formIsValid = formValidationResult.valid
    },
    async next() {
      await this.checkForm()
      if (!this.formIsValid) return

      if (this.cptdNextStep.key && this.cptdNextStep.index) {
        this.gEventBus.emit('layout-unlogged:display-back-button')
        document.body.scrollTo({ top: 0, behavior: 'smooth' })
        this.validation = false
        this.currentStep = this.steps[this.cptdNextStep.index]
        this.setRouteParams()
      } else {
        setTimeout(() => {
          this.submit()
        }, 200)
      }
    },
    submit() {
      this.$emit('submit')
    },
  },
}
</script>
<style lang="scss">
.InteractiveForm {
  height: 100%;
  max-width: 600px;
  margin: 0 auto;

  .back {
    margin-right: 3px;
  }
  .loading {
    min-height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .actions {
    margin-top: 8px;
  }

  & .slider-input & > .values {
    flex-direction: column;
    align-items: flex-start;

    & > label {
      @include headline-5;
      margin-bottom: 24px;
    }
  }

  & .check-input-wrapper {
    & > label {
      @include headline-5;
      margin-bottom: 8px;
    }
  }

  & .text-input {
    width: 100%;
    display: flex;
    flex-direction: column;
    margin: 0 0 16px 0;
    padding-bottom: 0;

    & > label {
      @include headline-5;
      margin-bottom: 8px;
    }

    & > .input-wrapper {
      & > .input-field {
        border-top: none;
        border-left: none;
        border-right: none;
        border-width: 1px;
        border-radius: 0;
        padding: 12px 16px 12px 0;

        &:focus,
        &.-valid,
        &.-invalid {
          border-width: 2px;
        }
      }
    }
  }

  & .RadioInputList {
    margin: 0;
    & > .title {
      margin-bottom: 8px;
      & > label {
        @include headline-5;
      }
    }
  }
}
</style>
